import React from "react";
import { Box, Typography  } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const ComingSoonPage: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h2" gutterBottom sx={{ fontWeight: "bold", color: "#1976d2" }}>
        {t("comingSoon.title")}
      </Typography>
      <Typography variant="subtitle1" gutterBottom sx={{ color: "#666", marginBottom: 4 }}>
        {t("comingSoon.description")}
      </Typography>

    </Box>
  );
};

export default ComingSoonPage;
